'use client';

import type { ProductToCompareT } from '../../../../../type/product/productComparison';
import { Button } from '@vs-shop/ui/button';
import { shouldAddToCartButtonBeDisabled } from '../../../../../shared/utils/stockValidation';
import { useIntl } from 'react-intl';

import { IconCartOutline } from '@vs-shop/ui/icons';

import { useAddToCart, useVariantInCart } from '../../../../../hook/useAddToCart';
import {
  useCartLinePreviewPreload,
  withCartLinePreview,
} from '../../../../../hook/cartLinePreview';

type Props = {
  product: ProductToCompareT;
};

export default function ProductComparisonAddProductToCartButton({ product }: Props) {
  const intl = useIntl();
  const addToCart = useAddToCart();
  const { quantityInCart, isAdding } = useVariantInCart(product.code);

  const amount = 1;
  const cartRequest = withCartLinePreview(
    { product, quantity: amount },
    product.imagePath,
    product.ageRestriction
  );
  const preloadHandlers = useCartLinePreviewPreload([cartRequest.preview]);
  const isDisabled =
    isAdding ||
    shouldAddToCartButtonBeDisabled(
      product.stock.eshop.maxOrderable,
      quantityInCart,
      amount,
      product.price
    );

  return (
    <Button
      variant="primary"
      size="sm"
      className="px-6"
      {...preloadHandlers}
      onClick={() => {
        addToCart([cartRequest]);
      }}
      loading={isAdding}
      disabled={isDisabled}
      data-slot="product-comparison-add-to-cart"
      data-product-code={product.code}
    >
      <IconCartOutline className="size-4 shrink-0" />
      <span className="text-sm leading-none uppercase">
        {intl.formatMessage({
          id: 'product.comparison.header.button.addProductToCart',
          defaultMessage: 'Do košíku',
        })}
      </span>
    </Button>
  );
}
